export default "__VITE_ASSET__CVAYFb19__"